module.exports = __webpack_public_path__ + "img/meta.40282ad7.svg";